import React from 'react';
import type {
  CandidateLegalTechSkill,
  GroupedExperiences,
  Taxonomy,
  User,
  BioRenderableCandidate,
} from '@axiom/validation';
import { isSalesUser, CandidateProfileUtils } from '@axiom/utils';

import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { Banner, BannerImpact, BannerType } from '../../element/Banner/Banner';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Flashy } from '../../element/Flashy/Flashy';

import { BioViewCandidate } from './BioViewCandidate';

export type BioViewProps = {
  candidate: BioRenderableCandidate;
  groupedExperiences: GroupedExperiences[];
  legalTechSkills: CandidateLegalTechSkill[];
  taxonomy: Taxonomy;
  user?: User;
  onNavigate?: (hideHighlights?: boolean, hideLocation?: boolean) => void;
  isAnonymous?: boolean;
};

export const BioView = ({
  candidate,
  groupedExperiences,
  legalTechSkills,
  taxonomy,
  user,
  onNavigate,
  isAnonymous = false,
}: BioViewProps) => {
  const showDownload =
    !isSalesUser(user) ||
    isAnonymous ||
    (isSalesUser(user) && CandidateProfileUtils.isProactiveOpen(candidate));
  return (
    <Gutter vertical="24px" name="BIO_VIEW">
      <Banner
        type={BannerType.CRITICAL}
        impact={BannerImpact.LOW}
        name="SHARE_BIO_BANNER"
      >
        <ParagraphHeader as="span">
          <Flashy color="textDefault">Sharing this bio with a client?</Flashy>
        </ParagraphHeader>{' '}
        {showDownload ? (
          <span data-test="BANNER_DOWNLOAD_TEXT">
            Click the download button below.
          </span>
        ) : (
          ''
        )}{' '}
        Clients can’t open bio links.
      </Banner>
      <Gutter bottom="24px" />
      <Flashy backgroundColor="panelLight">
        <BioViewCandidate
          candidate={candidate}
          groupedExperiences={groupedExperiences}
          legalTechSkills={legalTechSkills}
          taxonomy={taxonomy}
          user={user}
          onNavigate={onNavigate}
          isAnonymous={isAnonymous}
        />
      </Flashy>
    </Gutter>
  );
};
